// /client/src/components/SkillForm.js
import React, { useState, useEffect } from 'react';
import {
  Dialog, DialogActions, DialogContent, DialogTitle, TextField,
  Button, Stack, MenuItem
} from '@mui/material';

const categories = ['Frontend', 'Backend', 'Database', 'DevOps', 'Other'];

const SkillForm = ({ open, onClose, onSave, skill }) => {
  const [formData, setFormData] = useState({ name: '', category: 'Frontend' });

  useEffect(() => {
    if (skill) {
      setFormData({ name: skill.name, category: skill.category });
    } else {
      setFormData({ name: '', category: 'Frontend' });
    }
  }, [skill, open]);

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSave = () => {
    onSave(formData, skill ? skill._id : null);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>{skill ? 'Edit Skill' : 'Add New Skill'}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 2 }}>
          <TextField name="name" label="Skill Name" value={formData.name} onChange={handleChange} fullWidth required />
          <TextField name="category" label="Category" value={formData.category} onChange={handleChange} select fullWidth required>
            {categories.map((option) => (
              <MenuItem key={option} value={option}>{option}</MenuItem>
            ))}
          </TextField>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSave} variant="contained">Save</Button>
      </DialogActions>
    </Dialog>
  );
};

export default SkillForm;